import { defineComponent, ref, watch } from "vue";

type ImageLoadState = "loading" | "loaded" | "error";

export default defineComponent({
    name: "MessageImageAttachment",

    props: {
        href: String,
        name: String,
        src : String,
    },

    emits: {
        settled: () => true,
    },

    setup(props, { emit }) {
        const state = ref<ImageLoadState>("loading");

        watch(
            () => props.src,
            (src) => {
                state.value = src ? "loading" : "error";

                if (!src)
                    emit("settled");
            },
            { immediate: true },
        );

        function markLoaded() {
            state.value = "loaded";
            emit("settled");
        }

        function markFailed() {
            state.value = "error";
            emit("settled");
        }

        return () => (
            <a
                class={{
                    "log-message-image-attachment"        : true,
                    "log-message-image-attachment-loaded" : state.value === "loaded",
                    "log-message-image-attachment-error"  : state.value === "error",
                }}
                href={props.href || props.src}
                rel="noreferrer"
                target="_blank">
                {state.value === "loading" && (
                    <div class="log-message-image-attachment-skeleton" aria-label="Chargement de l'image" />
                )}

                {props.src && state.value !== "error" && (
                    <img
                        alt={props.name || "Image jointe"}
                        loading="lazy"
                        src={props.src}
                        onLoad={markLoaded}
                        onError={markFailed} />
                )}

                {state.value === "error" && (
                    <div class="log-message-image-attachment-failure">
                        <span aria-hidden="true">💩</span>
                        <strong>Chargement impossible</strong>
                    </div>
                )}
            </a>
        );
    },
});
